export default __webpack_public_path__ + "static/media/splash_logo.bd9edb9a.png";